// import { useEffect, useState } from 'react'
// import './formations.css'
// import { Link } from 'react-router-dom'
// import ReactBootstrapModal from '../../common/modals/ReactBootstrapModal'
// import { CreateFormations } from './CreateFormations/CreateFormations'
// import logger from '../../../utils/logger'
// import { LayoutRender } from './LayoutRender/LayoutRender'

// export const Formations = () => {

//     const [active, setActive] = useState("activos")

//     const handleClick = (e) => {
//         const value = e.target.dataset.base; // leer data-base
//         setActive(value);
//     }

//     useEffect(() => {
//         document.title = 'TPA® Admin - Envios'
//     }, [])



//     //? Setea el tipo de Modal que se visializara ALERT O MEMBERSHIP
//     const [bootstrapModalStatus, setBootstrapModalStatus] = useState(false);


//     const closeBootstrapModal = () => {
//         setBootstrapModalStatus(false);
//     }

//     const handleShow = () => {
//         setBootstrapModalStatus(true)
//     };

//     //consultar nombre de la URL
//     const URL = 'Formation'




//     useEffect(() => {
//         document.title = 'TPA® Admin - Formaciones'
//     }, [])



//     //? CONTROL DE ESTADO BOTONES ACTIVOS, INACTIVOS, B.AVANZADA

//     const [activeTab, setActiveTab] = useState(true)
//     const [showSearchBtn, setShowSearchBtn] = useState(false);


//     const handleActivo = () => {
//         setActiveTab(true)
//         setShowSearchBtn(false)

//     }

//     const handleInactivo = () => {
//         setActiveTab(false)
//         setShowSearchBtn(false)

//     }

//     const handleBusquedaAvanzada = () => {
//         setShowSearchBtn(true)

//     }

//     logger.debug('activeTab: ', activeTab)





//     return (

//         // Vista principal

//         <section className='formation-page'>


//             <div className='m-4'>

//                 <div className='formation-card-header'>
//                     <div className='formation-container-actions card-tools'>

//                         <h1 className='pull-left formation-page-title'>Formaciones</h1>

//                         {
//                             !bootstrapModalStatus &&
//                             <Link
//                                 to="#"
//                                 className="btn btn-new-formation me-0 me-md-5"
//                                 onClick={handleShow}
//                             >
//                                 <span className="material-symbols-outlined notranslate mi-add-formation">
//                                     add
//                                 </span>

//                                 <span className='d-none d-md-inline add-text'>
//                                     Crear
//                                 </span>

//                             </Link>
//                         }

//                     </div>
//                 </div>
//             </div>


//             <div className=" m-4">

//                 <div className="navigation-container d-flex gap-3" >
//                     <button
//                         className={`${active === 'activos' && 'activeTab'} btn navigation-btn `}
//                         data-base="activos"
//                         onClick={(e) => { handleActivo(); handleClick(e) }}>
//                         Activas
//                     </button>

//                     <button
//                         className={`${active === 'inactivos' && 'activeTab'} btn navigation-btn `}
//                         data-base="inactivos"
//                         onClick={(e) => { handleInactivo(); handleClick(e) }}>
//                         Finalizadas
//                     </button>

//                     <button
//                         className={`${active === 'busquedaAvanzada' && 'activeTab'} btn navigation-btn `}
//                         data-base="busquedaAvanzada"
//                         onClick={(e) => { handleBusquedaAvanzada(); handleClick(e) }}>
//                         Búsqueda avanzada
//                     </button>
//                 </div>
//             </div>






//             <LayoutRender
//                 activeTab={activeTab}
//                 url={URL}
//                 showSearchBtn={showSearchBtn}
//             />


//             <ReactBootstrapModal
//                 toggleModal={closeBootstrapModal}
//                 showModal={bootstrapModalStatus}
//                 modalClass={'modalFormation'}
//                 dialogClass={'formation-dialogClass ps-0'}


//             >



//                     <CreateFormations
//                         toggleModal={closeBootstrapModal}
//                         closeBootstrapModal={closeBootstrapModal}

//                     />



//             </ReactBootstrapModal>


//         </section>




//     )
// }








import { useEffect, useRef, useState } from 'react'
import './formations.css'
import { Link } from 'react-router-dom'
import ReactBootstrapModal from '../../common/modals/ReactBootstrapModal'
import { CreateFormations } from './CreateFormations/CreateFormations'
import logger from '../../../utils/logger'
import { LayoutRender } from './LayoutRender/LayoutRender'
import { MemberService } from '../../../services/MemberService'
import { LoadingComponent } from '../../common/LoadingComponent/LoadingComponent'
import { LoadingComponent2 } from '../../common/LoadingComponent/loadingComponent2/LoadingComponent2'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveBtn, setActiveTab } from '../../../redux/slices/formationNavegation'

export const Formations = () => {



    useEffect(() => {
        document.title = 'TPA® Admin - Envios'
    }, [])



    //? Setea el tipo de Modal que se visializara ALERT O MEMBERSHIP
    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(false);


    const closeBootstrapModal = () => {
        setBootstrapModalStatus(false);
    }

    const handleShow = () => {
        setBootstrapModalStatus(true)
    };

    //consultar nombre de la URL
    const URL = 'Formation'





    useEffect(() => {
        document.title = 'TPA® Admin - Formaciones'
    }, [])



    //? CONTROL DE ESTADO BOTONES ACTIVOS, INACTIVOS, B.AVANZADA

    // const [activeTab, setActiveTab] = useState(true)
    // const [showSearchBtn, setShowSearchBtn] = useState(false);


    const activeTab = useSelector((state) => state.formationsNav.activeTab)
    const activeBtn = useSelector((state) => state.formationsNav.activeBtn)
    const dispatch = useDispatch()

    const [showSearchBtn, setShowSearchBtn] = useState(false);



    const handleActivo = (e) => {
        // setActiveTab(true)
        setShowSearchBtn(false)
        dispatch(setActiveTab(true))
        dispatch(setActiveBtn(e.target.dataset.base))
    }

    const handleInactivo = (e) => {
        // setActiveTab(false)
        setShowSearchBtn(false)
        dispatch(setActiveTab(false))
        dispatch(setActiveBtn(e.target.dataset.base))

    }

    const handleBusquedaAvanzada = (e) => {
        setShowSearchBtn(true)
        dispatch(setActiveTab(true))
        dispatch(setActiveBtn(e.target.dataset.base))
    }


    //? esto lo llamás cuando se crea una formación nueva

    const [reloadTrigger, setReloadTrigger] = useState(0);

    const handleCreation = () => {

        setReloadTrigger(prev => prev + 1);
    }






    //?Manejador de la primera carga 

    const firstRender = useRef(false)


    const handleFirstRender = () => {

        if (firstRender) {
            firstRender.current = true
        }
    };


    logger.debug('firstRender: ', firstRender.current)



    const [totalFiltered, setTotalFiltered] = useState(null)
    const handleFiltered = (f) => {
        setTotalFiltered(f)
    }


    const [renderUsers, setRenderUsers] = useState([])
    const [loading, setLoading] = useState(false)


    const handleLoading = (value) => {
        setLoading(value)
    };

    useEffect(() => {


        const fetchUsers = async () => {

            if (activeBtn === 'busquedaAvanzada') {
                handleFiltered(null)
                handleLoading(false)
                handleFirstRender()
                setShowSearchBtn(true)
                return
            }

            handleLoading(true)


            const params = {

                Filter: activeTab ? "Active" : "Inactive"
            };

            try {

                const response = await MemberService.getMembers(params, URL);
                if (response) {
                    setRenderUsers(response.data);
                    handleFirstRender()
                    handleLoading(false)
                }

            } catch (err) {
                logger.error(err);
            }
        };

        fetchUsers();
    }, [activeTab, reloadTrigger, activeBtn])



    return (
        <>
            {firstRender.current ?
                <section className='formation-page'>


                    <div className='m-4'>

                        <div className='formation-card-header'>
                            <div className='formation-container-actions card-tools'>

                                <div className="title-decoration">
                                    <div class="accent-line"></div>
                                    <h1 className='pull-left formation-page-title mb-0'>Formaciones</h1>
                                </div>


                                {
                                    !bootstrapModalStatus &&
                                    <Link
                                        to="#"
                                        className="btn btn-new-formation me-0 me-md-5 mt-md-5"
                                        onClick={handleShow}
                                    >
                                        <span className="material-symbols-outlined notranslate mi-add-formation">
                                            add
                                        </span>

                                        <span className='d-none d-md-inline add-text'>
                                            Crear
                                        </span>

                                    </Link>
                                }

                            </div>
                        </div>
                    </div>


                    <div className=" m-4">

                        <div className="navigation-container d-flex gap-3" >
                            <button
                                className={`${activeTab && activeBtn === 'activos' && 'activeTab'} btn navigation-btn `}
                                data-base="activos"
                                onClick={(e) => { handleActivo(e); }}>
                                Activas
                            </button>

                            <button
                                className={`${!activeTab && activeBtn === 'inactivos' && 'activeTab'} btn navigation-btn `}
                                data-base="inactivos"
                                onClick={(e) => { handleInactivo(e); }}>
                                Finalizadas
                            </button>

                            <button
                                className={`${activeTab && activeBtn === 'busquedaAvanzada' && 'activeTab'} btn navigation-btn `}
                                data-base="busquedaAvanzada"
                                onClick={(e) => { handleBusquedaAvanzada(e); }}>
                                Búsqueda avanzada
                            </button>
                        </div>
                    </div>



                    <LayoutRender
                        activeTab={activeTab}
                        url={URL}
                        showSearchBtn={showSearchBtn}
                        renderUsers={renderUsers}
                        loading={loading}
                        handleLoading={handleLoading}
                        totalFiltered={totalFiltered}
                        handleFiltered={handleFiltered}

                    />








                    <ReactBootstrapModal
                        toggleModal={closeBootstrapModal}
                        showModal={bootstrapModalStatus}
                        modalClass={'modalFormation'}
                        dialogClass={'formation-dialogClass ps-0'}


                    >



                        <CreateFormations
                            toggleModal={closeBootstrapModal}
                            closeBootstrapModal={closeBootstrapModal}
                            handleCreation={handleCreation}

                        />



                    </ReactBootstrapModal>


                </section>
                :

                <div className='formation-loading-container'>

                    <LoadingComponent />
                    {/* <p>Cargando</p> */}

                </div>
            }
        </>







    )
}



